<template>
  <v-container fluid>
       <br>
       <v-form ref="form" v-model="validProfile">
         <v-flex class=margin-custom-width-left>
        <v-layout row>
           <v-flex xs5 sm4 md3>
                <v-text-field
                v-model="firstName"
                :rules="nameRules"
                label="First Name"
                ></v-text-field>
            </v-flex>
            <v-flex xs5 sm4 md3 offset-xs1>
                <v-text-field
                v-model="lastName"
                :rules="nameRules"
                label="Last Name"
                ></v-text-field>
            </v-flex>
         
        </v-layout>
         <v-layout row>
           <v-flex xs5 sm4 md3>
              <v-text-field
                v-model="phoneNumber"
                label="Phone"
                mask="phone"
                ></v-text-field>
            </v-flex>
            <v-flex xs5 sm4 md3 offset-xs1>
                 <v-checkbox
                    label="Opt for Text Alerts"
                    v-model="optTextAlert"
                  ></v-checkbox>
            </v-flex>
         
        </v-layout>
         <v-layout row>
            <v-flex xs5 sm4 md3>
                <v-text-field
                v-model="emailAddress"
                label="Email"
                :rules="emailRules"
                ></v-text-field>
            </v-flex>
            <v-flex xs5 sm4 md3 offset-xs1 >
                <v-btn color="primary"
                
                @click="saveProfile"
                >
                Save
                </v-btn>
                <v-btn color="info"
                
                @click="logout"
                >
                Logout
                </v-btn>
            </v-flex>
        </v-layout>
         </v-flex>
         </v-form>
        <br><br>
         <v-snackbar
          v-model="toast"
          color="success"
          :timeout=toastTimeout
          multi-line
        >
          {{ toastMessage }}
        </v-snackbar>
  </v-container>
</template>


<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    lastName: null,
    firstName: null,
    emailAddress: null,
    phoneNumber: null,
    optTextAlert: false,
    deletedIndex: -1,
    toast: false,
    toastMessage: null,
    toastTimeout: 5000,
    selectedAge: null,
    dialog: false,
    validAdd: false,
    validProfile: false,
    nameRules: [
      v => !!v || "Name is required",
      v =>
        /^\S+$/.test(v) ||
        "Please enter First name only. No spaces."
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    ageRules: [v => !!v || "Year of birth is required"]
  }),
  mounted() {
    this.lastName = this.user.lastName;
    this.firstName = this.user.firstName;
    this.emailAddress = this.user.email;
    this.phoneNumber = this.user.phoneNumber;
    this.optTextAlert = this.user.optTextAlert;

    let params = {accountId: this.user.id};

    this.getAgeGroups();
  },

  methods: {
    saveProfile() {
      if (this.$refs.form.validate()) {
        var account = {
          id: this.user.id,
          lastName: this.lastName,
          firstName: this.firstName,
          email: this.emailAddress,
          phoneNumber: this.phoneNumber,
          optTextAlert: this.optTextAlert
        };
        this.updateAccount(account).then(() => {
          this.toast = true;
          this.toastMessage = "Updated record";
        });
      }
    },
    logout() {
      this.logoutUser();
      this.$router.push({ path: "/login" });
    },
    ...mapActions("account", {
      updateAccount: "update"
    }),
    ...mapActions("ageGroup", { getAgeGroups: "get" }),
    ...mapActions("auth", ["logoutUser"])
  },

  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("ageGroup", ["ageGroups"])
  }
};
</script>